import { __assign } from "tslib";
import { h, render } from '@wk/custom-element';
export function buildElement(Element, props) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    document.body.innerHTML = '';
    render(document.body, h(Element, __assign({}, props), children));
    return document.querySelector(Element.tag);
}
export function select(element, selector) {
    return element.shadowRoot.querySelector(selector);
}
export function selectAll(element, selector) {
    return element.shadowRoot.querySelectorAll(selector);
}
